import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { initAnalytics, initWebVitals } from './analytics'
import { ThemeProvider } from './context/ThemeContext'
import { SiteSettingsProvider } from './context/SiteSettingsContext'
import './index.css'
import App from './App'

// Google Search Console: injects <meta name="google-site-verification" content="..."> into document.head (SPA, single domain)
const gsc = import.meta.env.VITE_GSC_VERIFICATION
if (typeof gsc === 'string' && gsc.trim()) {
  const meta = document.createElement('meta')
  meta.name = 'google-site-verification'
  meta.content = gsc.trim()
  document.head.appendChild(meta)
}

initAnalytics()
initWebVitals()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <SiteSettingsProvider>
          <App />
        </SiteSettingsProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
)
